import * as React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search, Laptop, Clock } from "lucide-react";
import { motion } from "framer-motion";
import { useGetBatchQuery } from "../store/batchApi";
import { Link } from "react-router-dom";
import { Batch } from "@/types";

const HrAttendance = () => {
  const [searchQuery, setSearchQuery] = React.useState("");
  const { data: batches } = useGetBatchQuery();

  const filteredBatches = batches?.filter(
    (batch: Batch) =>
      batch.courseName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      batch.bCode.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  return (
    <div className="min-h-screen bg-background text-foreground p-8">
      <div className="max-w-7xl mx-auto space-y-8">
        <div className="flex flex-col gap-6">
          <div className="flex items-center justify-between">
            <h1 className="text-3xl font-bold">Attendance</h1>
          </div>

          <div className="relative w-full md:w-2/3 lg:w-1/2">
            <Input
              placeholder="Search by batch name or code..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pl-12 pr-4 h-12  transition-all duration-200"
            />
            <Search
              className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400"
              size={20}
            />
            {searchQuery && (
              <Button
                variant="ghost"
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                onClick={() => setSearchQuery("")}
              >
                Clear
              </Button>
            )}
          </div>
        </div>

        {filteredBatches?.length === 0 ? (
          <div className="text-center py-12">
            <div className="text-gray-500">
              No batches found matching your search.
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredBatches?.map((batch: Batch, index: number) => (
              <motion.div
                key={batch._id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
              >
                <Link to={`/attendance/${batch.bCode}`}>
                  <Card className="group hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 overflow-hidden border">
                    <CardContent className="p-0">
                      <div className="p-6 space-y-4">
                        <div className="flex justify-between items-start">
                          <div className="space-y-2">
                            <h3 className="font-semibold text-foreground">
                              {batch.courseName}
                            </h3>
                            <p className="text-sm text-muted-foreground">
                              {batch.bCode}
                            </p>
                          </div>
                          <div className="border bg-muted p-3 rounded-lg transform group-hover:scale-110 transition-transform duration-300">
                            <Laptop className="text-blue-500" size={24} />
                          </div>
                        </div>

                        <div className="flex items-center gap-2 text-sm">
                          <div className="flex items-center gap-2 text-muted-foreground">
                            <Clock className="h-4 w-4" />
                            <span>
                              {batch.startTime && batch.endTime ? (
                                <>
                                  {new Date(
                                    `1970-01-01T${batch.startTime}:00`,
                                  ).toLocaleTimeString([], {
                                    hour: "numeric",
                                    minute: "2-digit",
                                    hour12: true,
                                  })}{" "}
                                  -{" "}
                                  {new Date(
                                    `1970-01-01T${batch.endTime}:00`,
                                  ).toLocaleTimeString([], {
                                    hour: "numeric",
                                    minute: "2-digit",
                                    hour12: true,
                                  })}
                                </>
                              ) : (
                                "-"
                              )}
                            </span>
                          </div>
                          {/* <div className="flex items-center gap-2 text-muted-foreground">
                            <Calendar className="h-4 w-4" />
                            <span>{formatDate(batch.startDate)}</span>
                          </div> */}
                        </div>
                      </div>

                      <div className="border-t border-gray-100">
                        <Button
                          className="w-full rounded-none h-14 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-medium transition-all duration-300"
                          onClick={() =>
                            console.log(
                              `Recording attendance for batch ${batch._id}`,
                            )
                          }
                        >
                          Record Attendance
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HrAttendance;
